export default "__VITE_ASSET__aftMi0m2__"